import ApplicationController from './application_controller'

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  connect () {
  }

  confirm (event) {
    // If the event target doesn't have the data-confirmsg attribute, look for the closest element with data-confirmmsg

    const closestElementWithConfirmMsg = event.target.closest('[data-confirmmsg]');

    const msg = closestElementWithConfirmMsg.dataset.confirmmsg || 'Are you sure you want to perform this action?'
    if (confirm(msg)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  confirmDelete(event){
    event.stopPropagation();
    if(this.confirm(event)) {
      event.preventDefault();
      const link = event.target.closest('a');
      const url = link.href;
      fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      .then(response => {
        if (response.ok) {
          // window.location.reload();
          // Fade out animation
          var deleteTarget = event.target.closest('.delete-item');
          if(deleteTarget == null){
            window.location.reload();
          }
          console.log("Deleting item ", deleteTarget);
          deleteTarget.style.transition = "opacity 0.5s ease";
          deleteTarget.style.opacity = "0";

          // After animation completes, remove the element
          setTimeout(function (){
            deleteTarget.remove();
          }.bind(this), 500);
        } else {
          alert('Error: Delete request failed');
        }
      })
      .catch(error => {
        alert('Error: Delete request failed');
      });
    }
  }
}
